module.exports = __webpack_public_path__ + "static/img/1689.edc9609.png";